module.exports = __webpack_public_path__ + "assets/fonts/GLPI.37192845.svg";